import GetAppIcon from '@material-ui/icons/GetApp';
import { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import { getHumanReadableDate, getRequest, postRequest } from '../../globalhelper/helper';
import globalhelper from '../../helper/globalhelper';
import '../CI/COD.css';
import { Table, TableHead, TableBody, TableRow, TableCell, Checkbox, Accordion, Box, AccordionSummary, Typography, AccordionDetails, Button, CircularProgress, Grid, TextField, Autocomplete, TableContainer, Paper, Dialog, DialogTitle, DialogContent, DialogActions, Tooltip } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment';
import { MenuItem, Select } from '@material-ui/core';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
const SelectTemp = ({
  label,
  name,
  value,
  options,
  onChange
}) => {
  return <>
      <Autocomplete size='small' fullWidth value={options.length === 1 ? options[0] : value || null} options={options.sort()} onChange={(event, newValue) => onChange({
      target: {
        name,
        value: newValue
      }
    })} renderInput={params => <TextField {...params} label={label} variant='outlined' />} />
    </>;
};
let options = [{
  label: 'Credit Card',
  value: 'CreditCard'
}, {
  label: 'Journal',
  value: 'Journal'
}, {
  label: 'Digital Wallet Accounting',
  value: 'DigitalWalletAccounting'
}, {
  label: 'Employee Cost',
  value: 'EmployeeCost'
}, {
  label: 'Employee Cost Accrued',
  value: 'EmployeeCostAccrued'
}, {
  label: 'Employee Cost FnF',
  value: 'EmployeeCostFnF'
}, {
  label: 'Employee Cost Accrued Reversal',
  value: 'EmployeeCostAccruedReversal'
}, {
  label: 'Employee Reimbursement',
  value: 'EmployeeReimbursement'
}, {
  label: 'Instructor Accrual Reversal',
  value: 'InstructorAccrualReversal'
}, {
  label: 'Instructor Cost Accrual',
  value: 'InstructorCostAccrual'
}, {
  label: 'Instructor Invoice',
  value: 'InstructorInvoice'
}, {
  label: 'Master List (Bill)',
  value: 'Master'
}, {
  label: 'Payment',
  value: 'Payment'
}, {
  label: 'Petty Cash',
  value: 'PettyCash'
}, {
  label: 'Period End Process',
  value: 'PeriodEndProcess'
}, {
  label: 'Transaction List (Bill)',
  value: 'Transaction'
}, {
  label: 'Vendor',
  value: 'Vendor'
}, {
  label: 'Vendor Advance Payment',
  value: 'VendorAdvancePayment'
}];
const SelectType = ({
  label,
  name,
  value,
  onChange
}) => {
  return <>
      <Autocomplete size='small' fullWidth value={options.find(opt => opt.value === value) || null} options={options} getOptionLabel={option => option.label} isOptionEqualToValue={(option, value) => option?.value === value} onChange={(event, newValue) => onChange({
      target: {
        name,
        value: newValue?.value
      }
    })} renderInput={params => <TextField {...params} label={label} variant='outlined' />} />
    </>;
};
const TallyInputUserSelect = () => {
  const [queryResult, setQueryResult] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [ReadMoreItem, setReadMoreItem] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [masterLedgerInfo, setMasterLedgerInfo] = useState([]);
  const [permanentData, setPermanentData] = useState([]);
  const [formData, setFormData] = useState({
    transtype: '',
    fromDate: '',
    toDate: '',
    companyName: ''
  });
  const [period, setPeriod] = useState(moment());
  const [year, setYear] = useState('');
  const [monthInInt, setMonthInInt] = useState('');
  const [showPopup, setShowpopup] = useState(false);
  const [filterTable, setFilterTable] = useState('');
  const [dropDown, setDropDown] = useState({
    parentName: [],
    primaryGroup: []
  });
  const [showError, setShowError] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const [companies, setCompanies] = useState([]);
  const [companyCode, setCompanyCode] = useState('');
  const [vendorDetails, setVendorDetails] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  useEffect(() => {
    if (companyCode !== '') {
      console.log(companyCode);
      getRequest(`api/edureka/getLedgerNameForTally?companycode=${companyCode} `).then(response => {
        if (response.res.data) {
          const data = JSON.parse(response.res.data);
          const tempParentName = data.filter(item => item !== undefined).map(item => item['Parent Name']);
          const tempPrimaryGroup = data.filter(item => item !== undefined).map(item => item['Primary Group']);
          setDropDown({
            parentName: [...new Set(tempParentName)],
            primaryGroup: [...new Set(tempPrimaryGroup)]
          });
        }
      });
    }
  }, [companyCode]);
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
      const responseData = response.res.data;
      const orgname = responseData.map(item => item.orgname);
      setCompanyDetails(responseData);
      setCompanies(orgname);
      if (orgname?.length === 1) setFormData(prev => ({
        ...prev,
        companyName: orgname[0]
      }));
    }).catch(err => console.log(err));
    var currentDate = moment();
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD');
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD');
    const selectedYear = currentDate.year();
    const monthIndex = currentDate.month();
    const monthNumber = monthIndex + 1 < 10 ? `0${monthIndex + 1}` : `${monthIndex + 1}`;
    setMonthInInt(monthNumber);
    setYear(selectedYear);
    setFormData(prev => ({
      ...prev,
      fromDate: firstDay,
      toDate: lastDay
    }));
  }, []);
  useEffect(() => {
    if (formData.companyName !== '') {
      console.log(companyDetails, 'here');
      const id = companyDetails.find(item => item.orgname === formData.companyName);
      const companyid = id?.orgid;
      setCompanyCode(companyid);
    }
  }, [formData.companyName]);
  const handleChange = () => {
    const {
      fromDate,
      toDate,
      transtype,
      companyName
    } = formData;
    console.log(formData);
    console.log(fromDate, toDate, transtype, companyName);
    if (fromDate && toDate && transtype !== 'Master' && transtype !== 'Journal' && transtype !== 'Transaction' && transtype !== 'CreditCard' && transtype !== 'PettyCash' && transtype !== 'InstructorInvoice' && transtype !== 'InstructorCostAccrual' && transtype !== 'InstructorAccrualReversal' && transtype !== 'PeriodEndProcess' && transtype !== 'DigitalWalletAccounting' && transtype !== 'Payment' && transtype !== 'EmployeeReimbursement' && transtype !== 'EmployeeCost' && transtype !== 'EmployeeCostAccrued' && transtype !== 'EmployeeCostFnF' && transtype !== 'Vendor' && transtype !== 'VendorAdvancePayment' && companyName && transtype) {
      setShowError(false);
      setWarningMessage('');
      setSelectedItems([]);
      setSelectedRowData([]);
      setSelectAll(false);
      setShowSpinner(false);
      setLoading(true);
      setMasterLedgerInfo([]);
      getRequest(`api/vr2/getBookClosureRecord?Company=${companyCode}&Year=${year}&Month=${monthInInt}`).then(resp => {
        if (resp.res.status === 'success') {
          let data = resp.res.data;
          if (data.Bill === 'close' && formData.transtype === 'Transaction') {
            setShowpopup(true);
          } else {
            Promise.all([getRequest(`api/edureka/getTallyDataForOtherReports?startDate=${formData.fromDate}&endDate=${formData.toDate}&type=${formData.transtype}&companycode=${companyCode}`), getRequest(`api/edureka/getDynamoLogsForTally`)]).then(([tallyResponse, statusResponse]) => {
              const tallyRes = JSON.parse(tallyResponse.res.data);
              if (!tallyRes.length) {
                setShowError(true);
                setWarningMessage('No data to display..Please try some other combination');
              }
              const statusRes = statusResponse.res.data;
              const res = tallyRes.filter(item => item['Ledger Name'] !== undefined).map((item, index) => {
                return item;
              });
              const combinedArray = tallyRes.map(item => {
                if (statusRes) {
                  // const matched = statusRes.find(val => item["Accounting Journal"] === val.ajlist)

                  const matched = statusRes.find(val => val.SK === item['Accounting Journal']);
                  if (matched) {
                    return {
                      ...item,
                      ...matched
                    };
                  } else {
                    return item;
                  }
                } else {
                  return item;
                }
              });
              setQueryResult(combinedArray);
              setFilterData(combinedArray);
              setPermanentData(combinedArray);
            }).catch(err => console.log(err)).finally(() => setLoading(false));
          }
        }
      }).catch(err => console.log(err)).finally(() => setLoading(true));
    } else if (fromDate && toDate && transtype && companyName) {
      setShowError(false);
      setWarningMessage('');
      setSelectedItems([]);
      setSelectedRowData([]);
      setSelectAll(false);
      setShowSpinner(false);
      setLoading(true);
      setMasterLedgerInfo([]);
      setVendorDetails([]);
      if (fromDate && toDate && transtype === 'Vendor' && companyName) {
        setQueryResult([]);
        setFilterData([]);
        setVendorDetails([]);
        Promise.all([getRequest(`api/edureka/getVendorDetails?startDate=${formData.fromDate}&endDate=${formData.toDate}&type=${formData.transtype}&companycode=${companyCode}`), getRequest(`api/edureka/getDynamoLogsForTally`)]).then(([response, dynamoResponse]) => {
          console.log(response.res.data, 'vendor status resposnse');
          console.log(dynamoResponse.res.data, 'vendor status response');
          const statusResponse = dynamoResponse.res.data;
          const VendorDetailResponse = response.res.data;
          if (VendorDetailResponse < 1) {
            setShowError(true);
            setWarningMessage('No data to display... Please try some other combination');
          } else {
            if (formData.transtype === 'Vendor') {
              const FilteredVendorDetailResponse = VendorDetailResponse.filter(item => item['VendorID'] !== undefined).map((item, index) => {
                return item;
              });
              const combinedArray = FilteredVendorDetailResponse.map(item => {
                if (statusResponse) {
                  const matched = statusResponse.find(val => val.SK === item['VendorID']);
                  if (matched) {
                    return {
                      ...item,
                      ...matched
                    };
                  } else {
                    return item;
                  }
                } else {
                  return item;
                }
              });
              setVendorDetails(combinedArray);
            }
          }
        }).catch(error => {
          setShowError(true);
          setWarningMessage('An error occurred while fetching data.');
        }).finally(() => setLoading(false));
        return;
      }
      getRequest(`api/vr2/getBookClosureRecord?Company=${companyCode}&Year=${year}&Month=${monthInInt}`).then(resp => {
        if (resp.res.status === 'success') {
          setLoading(true);
          let data = resp.res.data;
          if (data.Bill === 'close' && formData.transtype === 'Transaction') {
            setShowpopup(true);
          } else {
            Promise.all([getRequest(`api/edureka/getTallyDataFENew?startDate=${formData.fromDate}&endDate=${formData.toDate}&type=${formData.transtype}&companycode=${companyCode}`), getRequest(`api/edureka/getDynamoLogsForTally`)]).then(([tallyResponse, statusResponse]) => {
              const tallyRes = JSON.parse(tallyResponse.res.data);
              if (!tallyRes.length) {
                setShowError(true);
                setWarningMessage('No data to display..Please try some other combination');
              }
              const statusRes = statusResponse.res.data;
              if (formData.transtype === 'Master') {
                const res = tallyRes.filter(item => item['Ledger Name'] !== undefined).map((item, index) => {
                  return item;
                });
                const combinedArray = res.map(item => {
                  if (statusRes) {
                    const matched = statusRes.find(val => val.SK === item['Accounting Journal']);
                    if (matched) {
                      return {
                        ...item,
                        ...matched
                      };
                    } else {
                      return item;
                    }
                  } else {
                    return item;
                  }
                });
                setQueryResult(combinedArray);
                setFilterData(combinedArray);
                setPermanentData(combinedArray);
              } else if (formData.transtype === 'Transaction' || formData.transtype === 'Journal' || formData.transtype === 'CreditCard' || formData.transtype === 'PettyCash' || formData.transtype === 'InstructorInvoice' || formData.transtype === 'InstructorCostAccrual' || formData.transtype === 'InstructorAccrualReversal' || formData.transtype === 'PeriodEndProcess' || formData.transtype === 'DigitalWalletAccounting' || formData.transtype === 'Payment' || formData.transtype === 'EmployeeReimbursement' || formData.transtype === 'EmployeeCost' || formData.transtype === 'EmployeeCostAccrued' || formData.transtype === 'EmployeeCostFnF') {
                const res = tallyRes.filter(item => item['Ledger Name'] !== undefined).map((item, index) => {
                  return item;
                });
                const combinedArray = res.map(item => {
                  if (statusRes) {
                    const matched = statusRes.find(val => val.SK === item['Accounting Journal']);
                    if (matched) {
                      return {
                        ...item,
                        ...matched
                      };
                    } else {
                      return item;
                    }
                  } else {
                    return item;
                  }
                });
                setQueryResult(combinedArray);
                setFilterData(combinedArray);
                setPermanentData(combinedArray);
              }
            }).catch(err => console.log(err)).finally(() => setLoading(false));
          }
        } else {
          setShowError(true);
          setWarningMessage('No data to display..Please try some other combination');
        }
      }).catch(err => {
        console.log(err);
        setLoading(false);
      });
    } else {
      setShowError(true);
      setWarningMessage('Please fill all the required fields');
    }
  };
  const handleCheckboxChange = index => {
    const selected = [...selectedItems];
    console.log(selected, index);
    if (selected.includes(index)) {
      selected.splice(selected.indexOf(index), 1);
    } else {
      console.log(selected, index);
      selected.push(index);
    }
    setSelectedItems(selected);
    setSelectedRowData(selected);
  };
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectedRowData([]);
    } else {
      const allIndices = Array.from({
        length: filterData.length
      }, (_, i) => i);
      setSelectedItems(allIndices);
      const filteredColumns = filterData.filter(item => item.Status === 'Initiated' || item.Status === 'Success');
      const selectedRows = allIndices.map(index => filterData[index]['Accounting Journal']).filter(item => !filteredColumns.some(filteredItem => filteredItem['Accounting Journal'] === item));
      setSelectedItems(selectedRows);
      setSelectedRowData(selectedRows);
    }
    setSelectAll(!selectAll);
  };
  const handlePush = () => {
    setShowSpinner(true);
    if (formData.transtype !== 'Master' && formData.transtype !== 'Transaction' && formData.transtype !== 'Journal' && formData.transtype !== 'CreditCard' && formData.transtype !== 'PettyCash' && formData.transtype !== 'InstructorInvoice' && formData.transtype !== 'InstructorCostAccrual' && formData.transtype !== 'InstructorAccrualReversal' && formData.transtype !== 'PeriodEndProcess' && formData.transtype !== 'DigitalWalletAccounting' && formData.transtype !== 'Payment' && formData.transtype !== 'EmployeeReimbursement' && formData.transtype !== 'EmployeeCost' && formData.transtype !== 'EmployeeCostAccrued' && formData.transtype !== 'EmployeeCostFnF' && formData.transtype !== 'Vendor') {
      const request = {
        selectedItems: filterData,
        company: formData.companyName,
        type: formData.transtype,
        companycode: companyCode
      };
      postRequest(`api/edureka/convertJSON`, request).then(response => {
        handleChange();
      }).catch(err => {
        setQueryResult([]);
        setFilterData([]);
        setPermanentData([]);
        setShowError(true);
        setWarningMessage('Oops!! Something went wrong please try again after sometime');
      });
    } else {
      const uniqueFileName = `file_${uuidv4()}`;
      const request = {
        selectedRowData: selectedRowData,
        ledgerInfo: masterLedgerInfo,
        company: formData.companyName,
        type: formData.transtype,
        companycode: companyCode,
        filename: uniqueFileName
      };
      postRequest(`api/edureka/pushToTallyViaSFTP`, request).then(response => {
        toast.success('Successfully Initiated');
        handleChange();
      }).catch(err => {
        setQueryResult([]);
        setFilterData([]);
        setPermanentData([]);
        setMasterLedgerInfo([]);
        setShowError(true);
        setWarningMessage('Oops!! Something went wrong please try again after sometime');
      });
    }
  };
  const handleDateChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => {
      return {
        ...prev,
        [name]: value
      };
    });
  };
  const handleTypeChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => {
      return {
        ...prev,
        [name]: value
      };
    });
  };
  const handlePeriodChange = newValue => {
    if (newValue) {
      const selectedYear = newValue.year();
      const monthIndex = newValue.month();
      const startDate = moment([selectedYear, monthIndex, 1]);
      const endDate = moment(startDate).endOf('month');
      const monthNumber = monthIndex + 1 < 10 ? `0${monthIndex + 1}` : `${monthIndex + 1}`;
      setMonthInInt(monthNumber);
      setYear(selectedYear);
      // Update form data with formatted dates
      setFormData(prev => ({
        ...prev,
        fromDate: startDate.format('YYYY-MM-DD'),
        toDate: endDate.format('YYYY-MM-DD')
      }));
      setPeriod(newValue);
    }
  };
  const handleReset = () => {
    setFormData({
      transtype: '',
      fromDate: '',
      toDate: '',
      companyName: ''
    });
    setSelectedItems([]);
    setSelectedRowData([]);
    setSelectAll(false);
    setQueryResult([]);
    setFilterData([]);
    setShowError(false);
    setWarningMessage('');
    setLoading(false);
    setMasterLedgerInfo([]);
    setFilterTable('');
    setPeriod(moment());
    // setYear('');
    // setMonth('');
  };
  const handleItemSelect = (val, e) => {
    const {
      name,
      value
    } = e.target;
    const data = [...queryResult];
    const mappedData = data.map((item, index) => {
      if (item['Ledger Name'] === val['Ledger Name']) {
        return {
          ...item,
          [name]: value
        };
      } else {
        return item;
      }
    });
    setQueryResult(mappedData);
    setFilterData(mappedData);
    const masterList = mappedData.map(item => {
      return {
        ledger_name: item['Ledger Name'] || '',
        account_group: item['parentName'] || '',
        primary_group: item['primaryGroup'] || ''
      };
    });
    const uniqueArray = masterList.filter((item, index, array) => {
      const isDuplicate = array.findIndex(element => element.ledger_name === item.ledger_name && element.account_group === item.account_group && element.primary_group === item.primary_group) === index;
      return isDuplicate;
    });
    setMasterLedgerInfo(uniqueArray);
  };
  const handleFilterTable = e => {
    setFilterTable(e.target.value);
    let data = [];
    if (e.target.value === 'select') {
      setFilterData(queryResult);
    } else {
      data = permanentData.filter(item => item.Status && item.Status === e.target.value);
      setFilterData(data);
    }
  };
  const getAllocationColumnValue = item => {
    return <div style={{
      display: 'flex',
      padding: 4
    }}>
        <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
      }}>
          {(item['LobAllocValue'] || []).map(costCenter => costCenter ? Object.keys(costCenter).map((key, index) => <p key={`${key}_${index}`} style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'flex-start',
          whiteSpace: 'nowrap'
        }}>
                    {key}
                  </p>) : '')}
        </div>
        <div style={{
        flex: 1
      }}>
          {(item['LobAllocValue'] || []).map(costCenter => costCenter ? Object.values(costCenter).map((value, index) => <p key={`${value}_${index}`} style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'flex-end',
          whiteSpace: 'nowrap'
        }}>
                    {' '}
                    {globalhelper.currencyFormatter(value)}
                  </p>) : '')}
        </div>
      </div>;
  };
  const handleReadMore = index => {
    if (ReadMoreItem.includes(index)) {
      console.log(ReadMoreItem, 'remove');
      let updated = ReadMoreItem.filter(ind => ind !== index);
      setReadMoreItem(updated);
    } else {
      setReadMoreItem(prev => [...prev, index]);
    }
  };
  const handleVendorRowSelect = (item, index) => {
    const isSelected = selectedCheckboxes.includes(index);
    if (isSelected) {
      setSelectedCheckboxes(prev => prev.filter(i => i !== index));
      setSelectedRowData(prev => prev.filter((_, idx) => selectedCheckboxes[idx] !== index));
      setSelectedItems(prev => prev.filter((_, idx) => selectedCheckboxes[idx] !== index));
    } else {
      setSelectedCheckboxes(prev => [...prev, index]);
      setSelectedItems(prev => [...prev, item]);
      setSelectedRowData(prev => [...prev, item]);
    }
    setShowSpinner(false);
  };
  const handleVendorSelectAll = () => {
    if (selectedCheckboxes.length === vendorDetails.length) {
      setSelectedCheckboxes([]);
      setSelectedItems([]);
      setSelectedRowData([]);
    } else {
      const allIndexes = vendorDetails.map((_, index) => index);
      setSelectedCheckboxes(allIndexes);
      setSelectedItems(vendorDetails);
      setSelectedRowData([vendorDetails]);
    }
  };
  const handleVendorRowRemove = index => {
    setSelectedCheckboxes(prev => prev.filter(i => i !== index));
    setSelectedItems(prev => prev.filter((_, idx) => idx !== index));
  };
  return <>
      <Box>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1-content' id='panel1-header'>
            <Typography variant='h6'>Search</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container gap={2}>
              <Grid item xs={2}>
                <SelectTemp label='Company' name='companyName' options={companies} value={formData.companyName} onChange={handleDateChange} />
              </Grid>

              <Grid item xs={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker label='Period' value={period}
                // readOnly={loaded}
                openTo='month' minDate={moment().subtract(1, 'year').startOf('year')} maxDate={moment().endOf('year')} views={['year', 'month']} onChange={newValue => {
                  handlePeriodChange(newValue);
                }} renderInput={params => <TextField fullWidth size='small' {...params} />} />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={2}>
                <SelectType label='Type' name='transtype' value={formData.transtype} onChange={handleTypeChange} />
              </Grid>

              {!loading && permanentData.length ? <Grid item xs={2}>
                  <Autocomplete size='small' value={filterTable} options={['Select', 'Initiated', 'Not Processed', 'Failed', 'Success']} onChange={(event, value) => handleFilterTable({
                target: {
                  name: 'filterTable',
                  value
                }
              })} renderInput={params => <TextField {...params} label='Status' variant='outlined' />} />
                </Grid> : null}
              <Grid item xs={3}>
                <Button onClick={handleChange} variant='contained' color='primary'>
                  Submit
                </Button>
                <Button style={{
                marginLeft: '10px'
              }} onClick={handleReset} variant='contained' color='error'>
                  Reset
                </Button>

                {selectedRowData.length ? <Button style={{
                marginLeft: '10px'
              }} variant='contained' color='warning' disabled={showSpinner} onClick={handlePush}>
                    {showSpinner ? <>
                        <CircularProgress size={20} sx={{
                    marginRight: '8px'
                  }} />
                        Loading...
                      </> : 'Push to ERP'}
                  </Button> : null}

                {filterData?.length > 0 && <Button>
                    <CSVLink className='btn btn-success' filename='Tally.csv' data={queryResult.sort((a, b) => a['Accounting Journal'].localeCompare(b['Accounting Journal']))}>
                      <GetAppIcon fontSize='small' />
                    </CSVLink>
                  </Button>}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        {!loading && filterData.length && vendorDetails.length < 1 ? <Box>
            <TableContainer component={Paper}>
              <Table sx={{
            minWidth: 650
          }} aria-label='simple table'>
              <TableHead>
                <TableRow>
                  {(filterData.sort((a, b) => a['Accounting Journal'].localeCompare(b['Accounting Journal'])) && filterData.sort((a, b) => a['Accounting Journal'].localeCompare(b['Accounting Journal'])).length > 0 ? Object.keys(filterData.sort((a, b) => a['Accounting Journal'].localeCompare(b['Accounting Journal']))[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                  textAlign: 'left'
                }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {(filterData.sort((a, b) => a['Accounting Journal'].localeCompare(b['Accounting Journal'])) || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
                  let displayVal = val;
                  if (typeof val === 'number' && !Number.isInteger(val)) {
                    displayVal = val.toFixed(2);
                  } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                    displayVal = parseFloat(val).toFixed(2);
                  } else if (typeof val === 'boolean') {
                    displayVal = val ? 'Yes' : 'No';
                  } else if (val === null || val === undefined) {
                    displayVal = '';
                  } else if (typeof val === 'object') {
                    displayVal = JSON.stringify(val);
                  }
                  return <TableCell key={valIndex} sx={{
                    textAlign: 'left'
                  }}>
                          {String(displayVal)}
                        </TableCell>;
                })}
                  </TableRow>)}
              </TableBody>
            </Table>
            </TableContainer>
          </Box> : null}
      </Box>

      {showError && <div className='center-screen'>{warningMessage}</div>}

      {loading ? <div className='center'>
          <div className='wave'></div>
          <div className='wave'></div>
          <div className='wave'></div>
          <div className='wave'></div>
          <div className='wave'></div>
          <div className='wave'></div>
          <div className='wave'></div>
          <div className='wave'></div>
          <div className='wave'></div>
          <div className='wave'></div>
        </div> : null}

      <>
        <Dialog open={showPopup} onClose={() => setShowpopup(false)} disableEscapeKeyDown // Equivalent to keyboard={true}
      disableBackdropClick // Equivalent to backdrop="static"
      >
          <DialogTitle>Oops! This action cannot be done</DialogTitle>

          <DialogContent>{`The books have been closed for the selected period - ${period}`}</DialogContent>

          <DialogActions sx={{
          justifyContent: 'center'
        }}>
            <Button variant='contained' color='error' size='small' onClick={() => setShowpopup(false)}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>

      {vendorDetails && vendorDetails.length > 0 && filterData.length < 1 ? <div>
          <Table>
              <TableHead>
                <TableRow>
                  {(vendorDetails && vendorDetails.length > 0 ? Object.keys(vendorDetails[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
              textAlign: 'left'
            }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {(vendorDetails || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
              let displayVal = val;
              if (typeof val === 'number' && !Number.isInteger(val)) {
                displayVal = val.toFixed(2);
              } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                displayVal = parseFloat(val).toFixed(2);
              } else if (typeof val === 'boolean') {
                displayVal = val ? 'Yes' : 'No';
              } else if (val === null || val === undefined) {
                displayVal = '';
              } else if (typeof val === 'object') {
                displayVal = JSON.stringify(val);
              }
              return <TableCell key={valIndex} sx={{
                textAlign: 'left'
              }}>
                          {String(displayVal)}
                        </TableCell>;
            })}
                  </TableRow>)}
              </TableBody>
            </Table>
        </div> : null}
    </>;
};
export default TallyInputUserSelect;